import React, { useState} from "react";
import Card from "components/card";
import PopupButton from "components/button/PopupButton";
import { getVoucherMeta } from "variables/constants";
import VoucherDetails from "./VoucherDetails";
import { displayIcon } from "variables/icons";

const Voucher = ({ voucherData, ...props } = {}) => {
  const [open, setOpen] = useState(false);

  const {
    isTrending = false,
    isFeatured = false,
    isOutOfStock = false,
  } = props || {};

  const { icon: Icon, gradientFrom, gradientTo } = getVoucherMeta(voucherData?.category);

  return (
    <>
      <Card
        className={`relative gap-6 rounded-xl h-full flex flex-col overflow-hidden border
          transition-transform transition-shadow duration-200
          ${isFeatured ? "border-2 border-emerald-400" : "border-slate-200"}
          ${
            isOutOfStock
              ? "opacity-60 hover:shadow-none hover:scale-100"
              : "hover:shadow-xl hover:scale-[1.02]"
          }`}
      >
        <div className={`h-32 flex items-center justify-center relative vouchers bg-gradient-to-br ${gradientFrom} ${gradientTo}`}>
          {Icon && <Icon className="w-16 h-16 text-white opacity-90" />}

          {isTrending && !isOutOfStock && (
            <span className="absolute top-2 right-2 flex items-center gap-1 text-xs px-2 py-0.5 rounded-xl bg-gradient-to-r from-orange-500 to-pink-500 text-white">
              { displayIcon("Trophy","w-3 h-3")}
              Trending
            </span>
          )}

          {isFeatured && !isOutOfStock && (
            <span className="absolute top-2 left-2 flex items-center gap-1 text-xs px-2 py-0.5 rounded-xl bg-yellow-500 text-yellow-900">
              { displayIcon("Star","w-3 h-3 fill-yellow-900")}
              Featured
            </span>
          )}

          {isOutOfStock && (
            <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
              <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 text-xs font-medium bg-white text-zinc-900">
                Out of Stock
              </span>
            </div>
          )}
        </div>

        <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6 pb-3">
          <h4 className="text-[14px] line-clamp-1 title-text">{voucherData?.name}</h4>
          <p className="text-[11px] mt-1 muted-text">{voucherData?.tagline}</p>
        </div>

        <div className="px-6 pb-6 flex-1 flex flex-col">
          <p className="text-[12px] line-clamp-2 mb-4 muted-text">
            {voucherData?.description}
          </p>

          <div className="mt-auto space-y-3">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-[10px] muted-text">Value</p>
                <p className="text-[12px] font-medium title-text">
                  {voucherData?.minimum_denomination_value} - {voucherData?.maximum_denomination_value}
                </p>
              </div>
              <div className="text-right">
                <p className="text-[10px] muted-text">Points</p>
                <p className="text-[16px] font-bold text-emerald-600 flex items-center gap-1 dark:text-emerald-500">
                  { displayIcon("Sparkles","w-4 h-4")}
                  {voucherData?.minimum_denomination_value} - {voucherData?.maximum_denomination_value}
                </p>
              </div>
            </div>

            <div className="flex gap-2">
              <PopupButton id={`voucher_details_${voucherData?.merchant_id}`} 
                title="Voucher Details" 
                label="Details"
                modalWidth={600}
                disabled={isOutOfStock}
                btnClass="btn-small flex-1 h-8 border rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center hover:shadow-none hover:bg-slate-100 dark:text-white dark:hover:bg-white/10"
              >
                <VoucherDetails 
                  merchantId={voucherData?.merchant_id} 
                  onClose={() => setOpen(false)}
                  voucherData={voucherData}
                />
              </PopupButton>
              <PopupButton id={`voucher_addtocart_${voucherData?.merchant_id}`} 
                title="Add To Cart" 
                label="Add"
                modalWidth={600}
                disabled={isOutOfStock}
                iconName="ShoppingCart"
                btnClass="btn-small flex-1 h-8 border rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center bg-gradient-to-r from-emerald-600 to-purple-600 hover:from-emerald-700 hover:to-purple-700 hover:shadow-none text-white"
              >
                <VoucherDetails 
                  merchantId={voucherData?.merchant_id} 
                  onClose={() => setOpen(false)}
                  voucherData={voucherData}
                  showDescription={false}
                />
              </PopupButton>

              {/* <Button
                disabled={true}
                className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium outline-none h-8 rounded-md gap-1.5 px-3 flex-1 bg-gradient-to-r from-emerald-600 to-purple-600 hover:from-emerald-700 hover:to-purple-700 hover:shadow-none text-white"
                onClick={handleAdd}
              >
                <ShoppingCart className="w-4 h-4 mr-1" />
                Add
              </Button> */}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default Voucher;
